<template>
    <div class="row">
        <div v-if="filteredEducations.length > 0" class="col-12">
            <h3 class="education-direction mb-1">
                {{ direction.name }}
            </h3>
        </div>

        <education-cards
            v-for="education in filteredEducations"
            :key="education.id"
            class="col-12 col-lg-6 pb-1 pb-lg-2"
            :education="education"
        ></education-cards>
    </div>
</template>

<script>
import EducationCards from '@/components/education/education-card';

export default {
    components: {
        EducationCards
    },
    props: {
        direction: {
            type: Object,
            default() {
                return {};
            }
        },
        educations: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    computed: {
        filteredEducations() {
            return this.educations.filter(item => {
                return item.direction == this.direction.name;
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.education-direction {
    font-size: 1.5rem;
    padding: 0.5rem 1rem;
    background-color: $color-gray;
    width: 100%;
    display: block;
}
</style>
